export default __webpack_public_path__ + "static/media/sunandmoon.1c22906d.svg";